import React from 'react';
import TietosuojaselosteContent from '../../content/TietosuojaselosteContent';
import MobileLegalFrame from './MobileLegalFrame';

export default function MobileTietosuoja() {
  return (
    <MobileLegalFrame title="Tietosuojaseloste">
      <TietosuojaselosteContent />
    </MobileLegalFrame>
  );
}
